export const APP_LANGS = {
   POL: 'pol',
   ENG: 'eng',
   UKR: 'ukr',
   GER: 'ger'
};

const appInitialState = {
   priceItemId: '',
   initialized: false,
   lang: APP_LANGS.POL
};

const languagesAllowed = Object.values(APP_LANGS);

const app = (state = appInitialState, action) => {
   switch (action.type) {
      case 'SWITCH_LANG':
         localStorage.setItem('KNS_INFO_CURRENT_LANG', action.lang);
         return { ...state, lang: action.lang };
      case 'SIGN_OUT':
         localStorage.removeItem('token');
         return { ...state, user: null };
      case 'PRICE_ITEM_ID':
         return { ...state, priceItemId: action.priceItemId };
      case 'INITIALIZED': {
         const lang = localStorage.getItem('KNS_INFO_CURRENT_LANG');

         if (!lang || !languagesAllowed.includes(lang)) {
            localStorage.setItem('KNS_INFO_CURRENT_LANG', 'pol');

            return {
               ...state,
               initialized: action.initialized,
               lang: 'pol'
            };
         }

         return {
            ...state,
            initialized: action.initialized,
            lang
         };
      }

      default:
         return state;
   }
};

export default app;
